var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crown-button',_vm._g({attrs:{"id":"lane-below-button","aria-label":"Add lane below icon","src":_vm.laneBelowIcon,"width":25}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }